import { SearchGlobalApi } from '~/server/types'

export const useSearchStore = defineStore('Search', () => {
  const store = useStore()
  const { formatTransify } = store
  const { config } = storeToRefs(store)
  const searchTypes = computed(() => {
    let types: number[] = []
    if (config.value?.config?.search_status) {
      if (config.value?.config?.search_terms_tutorial_cl && config.value?.config?.search_terms_wiki_cl) {
        types = [4, 3]
      } else if (config.value?.config?.search_terms_tutorial_cl) {
        types = [4]
      } else if (config.value?.config?.search_terms_wiki_cl) {
        types = [3]
      }
    }
    return types
  })
  const selectOptions = computed(() => {
    const options = []
    options.push({
      value: 0,
      label: formatTransify('UGC_OFFICIAL_WEBSITE_SEARCH_ALL')
    })
    searchTypes.value.forEach((item) => {
      options.push({
        value: item,
        label:
          item === 3 ? formatTransify('UGC_OFFICIAL_WEBSITE_WIKI') : formatTransify('UGC_OFFICIAL_WEBSITE_TUTORIAL')
      })
    })
    return options
  })

  async function fetchSearchData(keyword: string, ingame = '0') {
    let res: SearchGlobalApi
    try {
      const result = await $fetch(`/api/search`, {
        method: 'POST',
        body: {
          search_type: searchTypes.value,
          keyword,
          lang_id: config.value.id,
          ingame
        }
      })
      res = result as SearchGlobalApi
    } catch (error) {
      res = {
        status: 'error',
        msg: '',
        data: {
          data: [],
          count: 0
        }
      }
    }
    return res
  }

  return {
    searchTypes,
    selectOptions,
    fetchSearchData
  }
})
